import script from "./HeadNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadNav.vue?vue&type=script&setup=true&lang=js"

import "./HeadNav.vue?vue&type=style&index=0&id=04e6ef0d&lang=scss"

const __exports__ = script;

export default __exports__